import React from 'react';
import { EXPERIENCE as roles } from '../data/profile';

export default function Experience() {
  return (
    <section id="experience" className="section">
      <div className="container">
        <h2>Experience</h2>
        <div className="timeline">
          {roles.map(r => (
            <div className="timeline-item reveal" key={r.period}>
              <div className="timeline-dot" />
              <div className="timeline-content">
                <div className="timeline-heading">
                  <strong>{r.role}</strong> · {r.org}{r.location ? ` (${r.location})` : ''}
                </div>
                <div className="muted">{r.period}</div>
                <p className="muted" style={{ marginTop: 6 }}>{r.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
